"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getWindow = require("ui-addon-upgrades/_core/common/navigation/getWindow");

var _isCompatible = function _isCompatible() {
  return Boolean((0, _getWindow.getWindow)().localStorage);
};

var LocalSettings = {
  get: function get(key) {
    if (!_isCompatible()) {
      return null;
    }

    return (0, _getWindow.getWindow)().localStorage.getItem(key);
  },
  set: function set(key, value) {
    if (!_isCompatible()) {
      return null;
    }

    (0, _getWindow.getWindow)().localStorage.setItem(key, value);
    return true;
  }
};
var _default = LocalSettings;
exports.default = _default;
module.exports = exports.default;